<template>
  <div class="buttons-container">
    <div v-for="e in buttonList" :key="e.id" class="main-button" @click="handleButtonFn(e.type)">
      <div class="google-shop-icon-box chxy-row-c-c">
        <img class="icon" :src="getImageUrlWithCDN_TEST(`/baixe/icon_${e.icon}.png`)" />
        <p class="value">{{ e.text }}</p>
      </div>
      <div class="gift-icon-box">
        <img class="icon" :src="getImageUrlWithCDN_TEST('/home/gift_icon.webp', 'local')" />
        <span class="value">{{ e.giftText }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useDevice } from '@/utils/useDevice'
import { debounce } from '@/utils/debounce'

const { t } = useI18n()

const buttonList = ref([
  {
    id: 1,
    text: t('download-popup-install-buttons-reg.downloadApp'),
    giftText: t('download-popup-install-buttons-reg.winR777'),
    icon: 'gift_pack',
    type: 'download',
  },
  {
    id: 2,
    text: t('download-popup-install-buttons-reg.depositNow'),
    giftText: t('download-popup-install-buttons-reg.depositBonus'),
    icon: 'wallet',
    type: 'deposite',
  },
])

const handleButtonFn = (type) => {
  switch (type) {
    case 'download':
      triggerInstallDebounce()
      break
    case 'deposite':
      emit('deposite')
      break
  }
}

const installPrompt = ref(null)
const { isIOS } = useDevice()

const init = (promptEvent) => {
  installPrompt.value = promptEvent
}

/**
 * 触发PWA安装流程
 */
function triggerInstall() {
  if (isIOS.value) {
    emit('download', { isIOS })
  } else {
    console.log('triggerInstall:', installPrompt.value)
    if (installPrompt.value) {
      // 使用之前保存的事件对象来触发安装提示
      installPrompt.value.prompt()

      // 等待用户选择结果
      installPrompt.value.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('用户同意安装')
        } else {
          console.log('用户拒绝安装')
        }
        // 清理保存的事件对象
        installPrompt.value = null
      })
      nextTick(() => {
        emit('download', { isIOS })
      })
    } else {
      emit('download', { isIOS })
    }
  }
}
const triggerInstallDebounce = debounce(triggerInstall)

onUnmounted(() => {
  installPrompt.value = null
})

const emit = defineEmits(['download', 'deposite'])

defineExpose({ init })
</script>

<style scoped lang="scss">
.buttons-container {
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 5px));
  grid-gap: 10px;

  .main-button {
    position: relative;
    width: 100%;
    height: 38px;
    line-height: 38px;
    text-align: center;
    font-size: 13px;
    border-radius: 6px;

    &:nth-of-type(1) {
      // background: var(--reg-greetings-popup-baixe-bg);
      // color: var(--reg-greetings-popup-baixe-text);
      background: var(--skin__home_bg);
      color: #ffdc83;
      border: 1px solid #ffdc83;
    }

    &:nth-of-type(2) {
      // background: var(--reg-greetings-popup-deposite-bg);
      // color: var(--reg-greetings-popup-deposite-text);
      background: #ffdc83;
      color: var(--skin__home_bg);
      border: 1px solid #ffdc83;
    }

    .google-shop-icon-box {
      .icon {
        width: 20px;
        height: 20px;
      }

      .value {
        margin-left: 4px;
      }
    }

    .gift-icon-box {
      position: absolute;
      top: -26px;
      right: -6px;
      line-height: 1;

      .icon {
        position: absolute;
        left: -20px;
        bottom: -8px;
        width: 24px;
        height: 24px;
      }

      .value {
        display: inline-block;
        padding: 4px;
        background-color: var(--reg-greetings-popup-gift-tag-bg);
        border-radius: 10px 10px 10px 0;
        font-size: 10px;
        font-weight: 700;
        color: var(--reg-greetings-popup-gift-tag-text);
      }
    }
  }
}
</style>
